export enum DocumentSendMethod {
  Both = 'BOTH',
  Email = 'EMAIL',
  Post = 'POST',
}
